import { ReactElement } from "react";
import { useRouter } from "next/router";
import { Content } from "~/components/aud/base/Content";
import { SectionTitle } from "~/components/aud/base/Section";

export const WithdrawalContent = ({ test = "settings-withdrew" }: { test?: string }): ReactElement => {
  const router = useRouter();
  return (
    <Content>
      <SectionTitle>退会</SectionTitle>
      <p>退会をご希望の場合はこちら</p>
      <div>
        <div onClick={() => router.push("/cancel_account")} className="_button primary" data-test={test}>
          退会はこちら
        </div>
      </div>
    </Content>
  );
};
